import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './utils/authTransport'
import App from './App.vue'
import router from './router'
import store from './store'

// Element Plus（按需自动导入，由 unplugin-auto-import + unplugin-vue-components 处理）
// 仅导入 locale 配置，组件和样式由 webpack 插件自动按需注入
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// Element Plus 样式保持唯一且稳定的全局顺序。组件 JS 仍由 resolver 按需导入；
// 避免异步路由分别注入样式后产生跨 chunk 的 CSS 顺序冲突。
import 'element-plus/dist/index.css'

// 全局样式
import './assets/styles/global.css'

// FontAwesome图标
import '@fortawesome/fontawesome-free/css/all.css'

// 存储管理器
import storageManager from './utils/storageManager'
import { registerMobileServiceWorker } from './pwa/registerMobileServiceWorker'

// 开发环境下加载代理测试器
if (process.env.NODE_ENV === 'development') {
  // 开发环境代理测试器（静默加载）
  import('./utils/testProxy.js').catch(() => {})
}

// 抑制ResizeObserver错误警告（开发环境常见的无害错误）
// 重写ResizeObserver以避免循环检测错误
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    const wrappedCallback = (entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer)
      })
    }
    super(wrappedCallback)
  }
}

// 全局错误处理器
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation()
    e.preventDefault()
    return false
  }
})

// 处理未捕获的Promise rejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault()
    return false
  }
})

const app = createApp(App)
const pinia = createPinia()

app.use(store)
app.use(pinia)
app.use(router)

// Element Plus 全局 locale 配置（组件由 unplugin 自动按需导入）
// 通过 provide 注入，让所有 ElConfigProvider 子组件继承
app.provide('ELEMENT_PLUS_LOCALE', zhCn)

// 初始化存储管理器
storageManager.initialize()

app.mount('#app')

router.isReady().then(() => registerMobileServiceWorker()).catch(() => {})
